<template>
    <div class="d-inline-block">
        <a class="btn btn-slide btn-lg btn-outline-secondary mr-1 mb-2 cursor-pointer" type="text" @click="dialogVisible = true">
            {{ __('site.Make-your-tour') }}
        </a>
        <el-dialog title="Tour Virtual" :visible.sync="dialogVisible" class="text-center" fullscreen custom-class="tourIframeDialog">
            <iframe height="100%" width="100%" src='https://my.matterport.com/show/?m=bYtZy8xUoB7&brand=0' frameborder='0' allowfullscreen allow='vr'></iframe>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dialogVisible: false
            }
        }
    }
</script>

<style>
    .tourIframeDialog>.el-dialog__body {
        height: 93%;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/TourVirtual.vue